import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
  },
  user: {
    backgroundColor: theme.palette.primary.alt,
    padding: theme.spacing(2),
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  profilePicture: {
    paddingBottom: "2rem",
  },
  displayName: {
    color: theme.palette.primary.contrastText,
    fontWeight: "bold",
    fontSize: 40,
  },
  buttons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "1rem",
  },
  username: {
    color: theme.palette.primary.contrastText,
    fontSize: 20,
  },
  settings: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      boxShadow:
        "0 12px 16px 0 rgba(0, 0, 0, 0.24), 0 17px 50px 0 rgba(0, 0, 0, 0.19)",
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  },
  logout: {
    color: theme.palette.primary.main,
    backgroundColor: "white",
    outlined: theme.palette.primary.main,
    "&:hover": {
      boxShadow:
        "0 12px 16px 0 rgba(0, 0, 0, 0.24), 0 17px 50px 0 rgba(0, 0, 0, 0.19)",
      color: theme.palette.primary.main,
      backgroundColor: "white",
    },
  },
  displayStats: {
    flexGrow: 3,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export default useStyles;
